<template>
  <div class="wrap">
    <div class="wrap-title">
      <div class="left">
        {{ curYear }}年{{ curMonth }}月
      </div>
      <div class="right">
        <span @click="preMonth()">上个月</span>
        <span @click="today()">今天</span>
        <span @click="nextMonth()">下个月</span>
      </div>
    </div>
    <!-- <i-btn size="md" color="primary" label="上个月" @click="preMonth" />
    <span>当前年份{{ curYear }}</span>
    <span>当前月份{{ curMonth }}</span>
    <i-btn size="md" color="primary" label="下个月" @click="nextMonth" /> -->
    <div class="weeks">
      <div v-for="item in week" :key="item" class="week">{{ item }}</div>
    </div>
    <div class="days">
      <div v-for="item in firstDay - 1" :key="item + 'pre'" class="lastday">
        <!-- {{ preDays - (firstDay - 1 - item) }} -->
      </div>
    <div style="position: relative;" v-for="item in curDays" :key="item + 'cur'" :class="['curday', Object.keys(markList).map(key => Number(key)).includes(item) ? ( markList[item].markType === 1 ? 'fullMark' : markList[item].markType === 2 ? 'notFullMark' : markList[item].markType === 3 ? 'closeMark' : '') : '']"  @click="getDetail(item)">
      <span :class="{'today': item === new Date().getDate() && curYear === new Date().getFullYear() && curMonth === new Date().getMonth() + 1}">{{ item }}</span>
      <div style="font-size: 12px;font-weight: 700;text-align: center;" v-if="markListKeys.includes(item) && (markList[item].markType === 1 || markList[item].markType === 2)">{{ markList[item].number }}人</div>
      <div style="font-size: 12px;font-weight: 700;text-align: center;" v-if="markListKeys.includes(item) && markList[item].markType === 3">关闭预约</div>
      <div style="position: absolute;top:4px;right:3px" v-if="markListKeys.includes(item) && markList[item].needRed" class="point"></div>
    </div>
      <div v-for="item in 7 - nextDays" :key="item + 'next'" class="lastday">
        <!-- {{ item }} -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
moment.suppressDeprecationWarnings = true
export default {
  props: {
    mark: {
      type: Object
    }
  },
  data () {
    return {
      markList: {},
      markListKeys: [],
      // mark: {
      //   6: {
      //     number: 99,
      //     markType: 1 // 1表示约满，2表示未约满，3表示关闭预约
      //   },
      //   7: {
      //     number: 88,
      //     markType: 2
      //   },
      //   8: {
      //     markType: 3
      //   },
      //   9: {
      //     number: 45,
      //     markType: 1,
      //     needRed: true
      //   },
      //   10: {
      //     number: 45,
      //     markType: 2,
      //     needRed: true
      //   }
      // },
      preDays: 30,
      nextDays: 7,
      curYear: moment().year(), // 当前年
      curMonth: moment().month() + 1, // 当前月
      week: ['一', '二', '三', '四', '五', '六', '日'],
      firstDay: moment(`${moment().year()}-${moment().month() + 1}`)
        .startOf('month')
        .day(), // 获取当月第一天是星期几;星期日为 0，星期六为 6
      curDays: moment().daysInMonth() // 获取当月一共有多少天
    }
  },
  mounted () {
    this.getPreMonthDays()
    this.getNextMonthDays()
  },
  watch: {
    mark: {
      handler (newVal) {
        this.markList = Object.assign({}, this.mark)
        this.markListKeys = Object.keys(this.mark).map(m => Number(m))
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getDetail (item) {
      const currentDay = `${this.curYear}-${this.curMonth < 10 ? '0' + this.curMonth : this.curMonth}-${item < 10 ? '0' + item : item}`
      this.$emit('openDetail', currentDay)
    },
    today () {
      const month = new Date().getMonth() + 1
      this.nextMonth(month)
    },
    preMonth () {
      this.curMonth--
      // 如果小于1表示上一年;重置日期
      if (this.curMonth < 1) {
        this.curYear--
        this.curMonth = 12
      }
      this.curDays = moment(`${this.curYear}-${this.curMonth}`).daysInMonth()
      this.firstDay = moment(`${this.curYear}-${this.curMonth}`).startOf('month').day()
      if (this.firstDay === 0) {
        this.firstDay = 7
      }
      const changDate = `${this.curYear}-${this.curMonth < 10 ? '0' + this.curMonth : this.curMonth}`
      this.$emit('changeDate', changDate)
      // 显示上个月日期
      this.getPreMonthDays()
      this.getNextMonthDays()
    },
    nextMonth (month) {
      if (month) {
        this.curMonth = month
      } else {
        this.curMonth++
      }
      // 如果超过12表示下一年;重置日期
      if (this.curMonth > 12) {
        this.curYear++
        this.curMonth = 1
      }
      this.curDays = moment(`${this.curYear}-${this.curMonth}`).daysInMonth()
      this.firstDay = moment(`${this.curYear}-${this.curMonth}`).startOf('month').day()
      if (this.firstDay === 0) {
        this.firstDay = 7
      }
      const changDate = `${this.curYear}-${this.curMonth < 10 ? '0' + this.curMonth : this.curMonth}`
      this.$emit('changeDate', changDate)
      // 显示上个月日期
      this.getPreMonthDays()
      this.getNextMonthDays()
    },
    // 获取上个月剩余天数
    getPreMonthDays () {
      if (this.firstDay === 1) return // 表示上个月无剩余天数
      let month = this.curMonth
      let year = this.curYear
      month--
      if (month === 0) {
        year--
        month = 12
      }
      // 获取上个月的天数
      const days = moment(`${year}-${month}`).daysInMonth()
      this.preDays = days
    },
    // 获取下个月要显示的天数
    getNextMonthDays () {
      const month = this.curMonth
      const year = this.curYear
      // 获取当月最后一天是星期几
      const lastDay = moment(`${year}-${month}`).endOf('month').day()
      this.nextDays = lastDay === 0 ? 7 : lastDay
    }
  }
}
</script>
<style lang="scss" scoped>
  .wrap {
    box-shadow: 0 0 0.52vw 0 rgba(0, 0, 0, 0.2);
    margin: 20px;
    width: 560px;
    border: 1px solid #ccc;
    padding: 20px;
    color: #000;
    font-family: blod;
    background-color: #fff;
    height: 100%;
    .wrap-title {
      padding-bottom: 5px;
      border-bottom: 1px solid #ccc;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .left {
        font-size: 14px;
        font-weight: 700;
      }
      .right {
        span {
          padding: 3px;
          font-size: 12px;
          color: #666;
          border: 1px solid #ccc;
          margin-left: -1px;
        }
        span:hover {
          cursor: pointer;
        }
      }
    }
    .weeks {
      height: 50px;
      display: flex;
      .week {
        width: 100%;
        // width: 80px;
        line-height: 50px;
        text-align: center;
        font-weight: 700;
      }
    }
    .days {
      display: flex;
      flex-wrap: wrap;
      .lastday,
      .curday {
        width: 75px;
        box-sizing: border-box;
        padding: 5px 0 0 10px;
        height: 50px;
        border: 1px solid #eee;
        margin-right: -1px;
        margin-bottom: -1px;
        font-size: 14px;
      }
      .curday:hover {
        cursor: pointer;
      }
      .lastday {
        color: gold;
      }
    }
  }
  .closeMark {
    color:#fff;
    background-color: #F76361;
  }
  .fullMark {
    color: #fff;
    background-color: rgb(64,149,229);
  }
  .notFullMark {
    color: #fff;
    background-color: rgb(129,179,55);
  }
  .point {
    width: 7px;
    height: 7px;
    border-radius: 7px;
    background-color: #F76361;
  }
  .active {
    background-color: rgb(64,149,229);
    color: #fff !important;
    border-color: rgb(64,149,229);
  }
  .today {
    color: rgb(232,110,48);
    font-weight: 700;
  }
  </style>
